module.exports = __webpack_public_path__ + "static/media/wifi-level-0-mobile.a8fdbad6.svg";